export const GradePolicy = {
  MASTERY: 'org.coursera.ondemand.coursematerial.MasteryGradePolicy',
  CUMULATIVE: 'org.coursera.ondemand.coursematerial.CumulativeGradePolicy',
} as const;
